








































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import UserType from '@/models/Users/UserType';
import { retrieveAndClearPKCEData } from '@/lib/pkce';

@Component({
  name: 'EntraCallback',
  components: { Alert }
})
export default class EntraCallback extends Vue {
  private loading = true;
  private error = false;
  private errorMessage = '';

  async mounted() {
    await this.handleCallback();
  }

  async handleCallback() {
    try {
      // Get authorization code and state from URL
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const errorParam = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');

      // Handle OAuth errors from Microsoft
      if (errorParam) {
        this.error = true;
        this.errorMessage = errorDescription || 'Authentication was cancelled or failed.';
        this.loading = false;
        return;
      }

      if (!code) {
        this.error = true;
        this.errorMessage = 'No authorization code received.';
        this.loading = false;
        return;
      }

      // Retrieve PKCE data from session storage
      const pkceData = retrieveAndClearPKCEData();

      if (!pkceData) {
        this.error = true;
        this.errorMessage = 'Session expired. Please try logging in again.';
        this.loading = false;
        return;
      }

      // Verify state to prevent CSRF
      if (state !== pkceData.state) {
        this.error = true;
        this.errorMessage = 'Invalid state parameter. Please try logging in again.';
        this.loading = false;
        return;
      }

      // Exchange authorization code for Firebase custom token
      await AppModule.exchangeEntraCode({
        code: code,
        codeVerifier: pkceData.codeVerifier,
        email: pkceData.email,
        nonce: pkceData.nonce
      });

      // If we get here, authentication was successful
      await this.handlePostLogin();

    } catch (error) {
      console.error('EntraCallback: authentication failed:', error);
      this.error = true;
      this.errorMessage = 'Authentication failed. Please try again.';
      this.loading = false;
    }
  }

  async handlePostLogin() {
    await AppModule.getUserProfile();
    if (AppModule.userProfile.userType === UserType.Undefined) {
      // Get profile failed - error will be displayed
      this.error = true;
      this.errorMessage = 'Failed to load user profile.';
      this.loading = false;
      return;
    }

    switch (AppModule.userProfile.userType) {
      case UserType.Company: {
        break;
      }
      case UserType.SysAdmin: {
        this.$router.push({ name: PageNames.SysAdminAgencies });
        break;
      }
      case UserType.Agency: {
        // Get the current agency context for subsequent request headers
        await AppModule.getAgencyContext(AppModule.userProfile.agencyIdentifiers[0].id);
        this.$router.push({ name: PageNames.AgencyDashboard });
        break;
      }
    }
  }

  goToLogin() {
    this.$router.push({ name: PageNames.Login });
  }
}
